import { customElement, property } from "lit/decorators.js";
import { html, LitElement, css } from "lit";
import { Parameter } from "@reporting/rp-types/etl";
import { SerializedValue, TreeAdapter, TreeDropdown } from "@omegagrid/tree";
import { FormTextInput, FormNumericInput, FormCheckbox, CalendarDateInput } from "@omegagrid/form";
import { choose } from "lit/directives/choose.js";
import { createRef, ref } from "lit/directives/ref.js";

function getPrameterUIType(parameter: Parameter) {
	const t = parameter.data_type;
	if (parameter.id_thread_list != null) {
		return /^table/i.test(t) || /n?varchar(max)/i.test(t) ? 'm' : 's';
	} else if (/bit/i.test(t)) {
		return 'b';
	} else if (/int/i.test(t)) {
		return 'n';
	} else if (/date/i.test(t)) {
		return 'd';
	} else {
		return 't';
	}
}

@customElement('rp-sql-parameter')
export class SqlParameter extends LitElement {

	static styles = css`
		:host {
			display: block;
		}

		og-input {
			display: block;
			height: 20px;
		}

		og-form-checkbox {
			margin-top: 4px;
		}
	`;

	@property({type: Object})
	parameter: Parameter;

	@property({type: Object})
	treeAdapter: TreeAdapter;

	componentRef = createRef<HTMLElement>();
	get component() { return this.componentRef?.value }

	get value() {
		let value: unknown = null;
		switch(getPrameterUIType(this.parameter)) {
			case 's':
				value = (this.component as TreeDropdown).value;
				return value && Array.isArray(value) && value[0] && value[0][0] ? value[0][0] : null;
			case 'm':
				return (this.component as TreeDropdown).value;
			case 't':
				return (this.component as FormTextInput).value;
			case 'n':
				return (this.component as FormNumericInput).value;
			case 'b':
				return (this.component as FormCheckbox).value;
			case 'd':
				return (this.component as CalendarDateInput).value;
			default: return null;
		}
	}

	getTreeValue(): SerializedValue[] {
		if (this.parameter.default_value_sql || this.parameter.default_value == null || this.parameter.default_value === '') return null;
		if (this.parameter.default_value.charAt(0) == '[') {
			return JSON.parse(this.parameter.default_value);
		} else {
			return [[this.parameter.default_value, 0, 1]];
		}
	}

	render = () => html`
		${choose(getPrameterUIType(this.parameter), [
			['m', () => html`
				<og-tree-dropdown ${ref(this.componentRef)}
					.adapter="${this.treeAdapter}"
					.value="${this.getTreeValue()}"
					cross>
				</og-tree-dropdown>
			`],
			['s', () => html`
				<og-tree-dropdown ${ref(this.componentRef)}
					.adapter="${this.treeAdapter}"
					.value="${this.getTreeValue()}"
					cross>
				</og-tree-dropdown>
			`],
			['t', () => html`
				<og-form-textinput ${ref(this.componentRef)}></og-form-textinput>
			`],
		 	['n', () => html`
				<og-form-numericinput ${ref(this.componentRef)}></og-form-numericinput>
		 	`],
			['b', () => html`
				<og-form-checkbox ${ref(this.componentRef)}></og-form-checkbox>
			`],
			['d', () => html`
				<g-form-calendardateinput ${ref(this.componentRef)}></g-form-calendardateinput>
			`]
		])}
	`;

}
